import { ReactElement } from 'react';
import { AppLink } from '../../../core/components';
import { usePageTitle } from '../../../core/hooks';
import { tokens } from '../../../core/theme';

export const NotFoundPage = (): ReactElement => {
  usePageTitle('Página não encontrada');

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Página não encontrada</h1>
      <p style={styles.message}>
        A página que você procura não existe ou não está mais disponível.
      </p>
      <AppLink to={'/'} style={styles.backLink}>
        Voltar para o início
      </AppLink>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacing.default,
    padding: tokens.spacing.default,
  },
  title: {
    margin: 0,
    fontSize: tokens.typography.fontSize.title,
    fontWeight: tokens.typography.fontWeight.semiBold,
    color: tokens.colors.brand.gray.DEFAULT,
  },
  message: {
    margin: 0,
    fontSize: tokens.typography.fontSize.caption,
    color: tokens.colors.brand.gray.light150,
  },
  backLink: {
    color: tokens.colors.brand.red.DEFAULT,
    fontSize: tokens.typography.fontSize.caption,
  },
};
